module.exports = __webpack_public_path__ + "img/跳转.9213ebc8.svg";